import React, {useState} from 'react';
import {useTheme} from "../../common/ProjectThemeProvider";
import {Anchor, Image, Label, PdfViewer} from "../../common/fusion-ui";
import {checkNullStr} from '../../common/fusion-ui/utils/ReactUtils';

const PdfOrImgViewer = ({
                            className,
                            wrapperClassName = '',
                            labelClassName = '',
                            wrapperStyle = {},
                            labelStyle = {},
                            style = {},
                            src,
                            fileExt,
                            label = '',
                            heightPx = '450px',
                            nullMsg = '',
                            linkForPreview = '', // nullMsg = 'File preview not available!',
                            width,
                            labelAt = 'start',
                            labelColor,
                            ...rest
                        }) => {
    const theme = useTheme();
    const [loadErrOccurred, setLoadErrOccurred] = useState(false);

    return (((checkNullStr(src) && !loadErrOccurred)) && <div className={`${wrapperClassName} mt-3`}
                                                              style={wrapperStyle}>
        {/*<div>*/}
        {/*<p>fileExt: {fileExt}</p>*/}
        {/*    <p>src: {src}</p>*/}
        {/*</div>*/}
        {/*doc-file-link*/}
        {/*{(IsProd && isFileDocument()) && <div className={'mt-3 bg-info'}>*/}
        {(isFileDocument()) && <div className={'mt-3 bg-infox'}>
            <div className={'text-nowrap flex-nowrap fw-bold'}>
                <Label className={''} color={theme.text}>Attached File</Label>
            </div>
            <Anchor
                className={'text-wrap'}
                href={src}
                simple={true}
                target={'_blank'}>
                {fileExt}
            </Anchor>
        </div>}

        {/*pdf*/}
        {(checkNullStr(src) && !loadErrOccurred) && <div>
            {isFilePdf() ? <PdfViewer
                className={`${className} mt-2`}
                label={''}
                src={src}
                height={heightPx}
                // height={'500px'}
                // onError={handleLoadError}
                {...rest}
            /> : (!isFileDocument()) && <Image
                className={`rounded-5 ${className}`}
                width={'100%'}
                // height={vhToPx(heightPx) + 'px'}
                height={heightPx}
                src={src}
                onError={handleLoadError}
                {...rest}
            />}
        </div>}
    </div>);

    function handleLoadError() {
        setLoadErrOccurred(true);
    }

    function isFilePdf() {
        return (fileExt + '').toLowerCase().trim().endsWith('.pdf') || (src + '').toLowerCase().includes('data:application/pdf')
        // return (fileExt + '').toLowerCase().trim().endsWith('.pdf')
    }

    function isFilePpt() {
        const name = (fileExt + '').toLowerCase().trim();
        return name.endsWith('ppt') || name.endsWith('pptx');
    }

    function isFileDocument() {
        return isFilePpt() || isFilePdf();
    }
};

export default PdfOrImgViewer;
